import { isNil } from 'ramda'
import { formatNumber } from 'src/utils/formatters'
import { formatValorLote } from 'src/utils/formatters/formatValorLote'

// Em Por Margem, Frete Subcontratado PJ/PF é o percentual de custo, não um valor em reais.
export function formatFreteSubcontratado(
  valor: number | undefined | null,
  tipoNegociacaoSubcontratado?: string,
  naLabel?: string
): string {
  if (tipoNegociacaoSubcontratado !== 'MARGEM') {
    return formatValorLote(valor ?? undefined, naLabel)
  }

  return isNil(valor)
    ? naLabel || 'Não Informado'
    : `${formatNumber(valor, 2)}%`
}

// Planilhas: valores em R$ seguem numéricos; em Por Margem vai o texto com o percentual.
export function freteSubcontratadoParaPlanilha(
  valor: number | undefined | null,
  tipoNegociacaoSubcontratado?: string
): number | string | undefined | null {
  return tipoNegociacaoSubcontratado === 'MARGEM' && !isNil(valor)
    ? formatFreteSubcontratado(valor, tipoNegociacaoSubcontratado)
    : valor
}
